import { render } from "./AllNotificationsModal.vue?vue&type=template&id=43e06be0&scoped=true&lang=pug"
import script from "./AllNotificationsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AllNotificationsModal.vue?vue&type=script&setup=true&lang=js"

import "./AllNotificationsModal.vue?vue&type=style&index=0&id=43e06be0&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e06be0"]])

export default __exports__